/*
 * @Author: Tango
 * @Date: 2020-12-24 14:23:23
 * @Last Modified by: Roger
 * @Last Modified time: 2021-02-02 10:45:20
 */
<template>
  <div id="planDetail">
    <a-spin :spinning="spinning">
      <content-title :showBack="true" :route="{name: 'planning'}" title="企划详情"></content-title>
      <div class="content" v-if="Object.keys(planInfo).length > 0">
        <div class="plan-item">
          <h4 class="name">{{ planInfo.name }}</h4>
          <div class="right-info">
            <span class="status-button">
              <a-badge :status="statusMap[planInfo.status].status" :text="statusMap[planInfo.status].text" />
            </span>
          </div>
          <p class="label" v-if="planInfo.label">
            <span class="label-item" v-for="(label, i) in planInfo.label.split(',')" :key="i">{{ label }}</span>
          </p>
          <div class="plan-author" v-if="planInfo.avatar || planInfo.username">
            <img class="plan-author__avatar"
              v-if="planInfo.avatar"
              :src="`${constv.QINIU_IMAGE_CND_URL}${planInfo.avatar}`"
              :alt="planInfo.username" />
            <div class="plan-author__nickname" v-if="planInfo.username">{{ planInfo.username }}</div>
          </div>
          <p class="date" style="margin-bottom: 16px">
            <span>作品类型：{{ categoryMap[planInfo.category] }}</span>
          </p>
          <p class="date">
            <span>征集时间：{{ planInfo.start_time }} 至 {{ planInfo.end_time }}</span>
          </p>
          <p class="line"></p>
          <div class="detail">
            <div class="detail-content">
              <div v-if="planInfo.status == '1' || planInfo.status == '2'">
                <p class="detail-title">企划详情</p>
                <div v-html="planInfo.details"></div>
              </div>
              <div v-else>
                <div v-if="planInfo.list.length > 0" class="result-list">
                  <p class="detail-title">选定结果展示</p>
                  <div class="result-item" v-for="(item, index) in planInfo.list" :key="index">
                    <div class="avatar-info">
                      <img
                        :src="`${
                          item.avatar.indexOf('app/') > -1
                            ? constv.QINIU_IMAGE_QNC_CDN_URL
                            : constv.QINIU_IMAGE_USERRESOURCE_CND_URL
                        }${item.avatar}`"
                        class="avatar"
                        alt=""
                      />
                      <span style="margin-left: 10px">{{ item.username }}</span>
                      <a-divider style="height: 14px; top: 0; margin: 0 20px" type="vertical" />
                      <span>{{ item.title }}</span>
                    </div>
                    <div class="work-list">
                      <package-list
                        :activeItem="{ catetory: planInfo.category, res_data: item.images }"
                        :option="{ itemWidth: 158, itemHeight: 158 }"
                      ></package-list>
                    </div>
                  </div>
                </div>
                <div class="empty-status" v-else>
                  <div style="text-align: center">
                    <i style="display: block; margin-bottom: 10px" class="icon-icon_password_16"></i>
                    <span>选定结果不公开</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="join-btn" v-if="planInfo.status == '1'">
              <a-button
                style="width: 112px; height: 40px; background-color: #ff7401; border-color: #ff7401; border-radius: 8px"
                type="primary"
                @click="goContribute"
              >我要投稿</a-button
              >
            </div>
          </div>
        </div>
      </div>
    </a-spin>

    <z-modal ref="showConfirmModal" :bodyStyle="{ padding: '24px 24px 40px 24px' }" :width="416">
      <div class="error-modal">
        <i class="icon-icon_xiaolian icon"></i>
        <span class="tips-text">需要先通过认证才可以参与企划哦~</span>
        <a-button type="primary" style="width: 94px; height: 40px" @click="goAuthor">去认证</a-button>
      </div>
    </z-modal>
  </div>
</template>

<script >
import contentTitle from '@/components/Zpace/common/contentTitle'
import packageList from '@/components/Zpace/packageList/packageList'
export default {
  name: 'PlanDetail',
  data () {
    return {
      categoryMap: {
        1: '场景',
        2: '贴图',
        3: '人设背景'
      },
      statusMap: {
        0: {
          text: '未开始',
          status: 'default'
        },
        1: {
          text: '进行中',
          status: 'processing'
        },
        2: {
          text: '评选中',
          status: 'success'
        },
        3: {
          text: '已结束',
          status: 'default'
        }
      },
      planInfo: {},
      id: this.$route.params.id,
      spinning: false
    }
  },
  components: { contentTitle, packageList },
  computed: {
    userInfo () {
      return this.$store.state.user.info
    }
  },
  created () {},
  mounted () {
    this.getInfo()
  },
  methods: {
    getInfo () {
      this.spinning = true
      this.$api.planning
        .getPlanningDetail({ id: this.id })
        .then((res) => {
          if (res.status === 'ok') {
            this.planInfo = res.data
          }
        })
        .finally(() => {
          this.spinning = false
        })
    },
    goContribute () {
      if (this.userInfo.authentication_status == '0') {
        this.$refs.showConfirmModal.showModal()
      }
      if (this.userInfo.authentication_status == '1' || this.userInfo.authentication_status == '3') {
        this.$message.error('认证申请通过以后才可以参与企划噢！')
      } else if (this.userInfo.authentication_status == '2') {
        this.$router.push({
          path: `/manage/planContribute/${this.id}`
        })
      }
    },
    goAuthor () {
      this.$router.push({
        path: '/manage/userAuthentication'
      })
    }
  }
}
</script>

<style lang='less' scoped>
#planDetail {
  background-color: #ffffff;
  min-height: 580px;
  .content {
    padding: 36px;
    .plan-item {
      position: relative;
      .plan-author {
        display: inline-flex;
        margin-bottom: 16px;
        font-size: 12px;
        align-items: center;
        color: #999;
        &__avatar {
          width: 24px;
          height: 24px;
          border: 1px solid #E5E5E5;
          border-radius: 50%;
          margin-right: 8px;
        }
      }
      .right-info {
        position: absolute;
        right: 0;
        top: 0;
        font-size: 12px;
        .info {
          color: #999999;
          .num {
            color: #ff7401;
          }
        }
      }
      .name {
        line-height: 1;
        color: #333333;
        font-size: 16px;
        margin-bottom: 16px;
        padding-left: 2px;
      }
      .label {
        margin-bottom: 16px;
        .label-item {
          border: 1px solid #e5e5e5;
          border-radius: 12px;
          color: #999999;
          padding: 5px 11px;
          display: inline-block;
          margin-right: 12px;
          box-sizing: border-box;
          font-size: 12px;
          line-height: 1;
        }
      }
      .date {
        line-height: 1;
        font-size: 12px;
        color: #999999;
      }
      .line {
        margin: 24px 0;
        width: 100%;
        height: 1px;
        background-image: linear-gradient(to right, #e5e5e5 0%, #e5e5e5 40%, transparent 60%);
        background-size: 8px 1px;
        background-repeat: repeat-x;
      }
      .detail {
        .join-btn {
          margin-top: 40px;
        }
        .detail-title {
          font-size: 16px;
          color: #333333;
          line-height: 1;
          margin-bottom: 24px;
        }
        .detail-content {

          .result-list {
            .result-item {
              padding: 24px;
              border-radius: 8px;
              border: 1px solid #f2f2f2;
              &:not(:last-child) {
                margin-bottom: 24px;
              }

              .avatar-info {
                display: flex;
                align-items: center;
                margin-bottom: 20px;
                .avatar {
                  width: 32px;
                  height: 32px;
                  border-radius: 50%;
                  display: block;
                  border: 1px solid #e5e5e5;
                  box-sizing: border-box;
                }
                span {
                  line-height: 1;
                  font-size: 14px;
                  color: #999999;
                }
              }
              .work-list {
                /deep/ .element-list .element-item {
                  // margin-right: 32px;
                }
              }
            }
          }
        }
      }
      .empty-status {
        height: 315px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #f2f2f2;
        border-radius: 8px;
        span {
          color: #bbbbbb;
          font-size: 14px;
        }
        i {
          font-size: 36px;
          color: #cccccc;
        }
      }
    }
  }
}
.error-modal {
  text-align: center;
  .icon {
    font-size: 36px;
    color: #fab11f;
    display: block;
    margin: 16px 0 28px;
    line-height: 1;
  }
  .tips-text {
    font-size: 18px;
    color: #333333;
    margin-bottom: 32px;
    display: block;
    line-height: 1;
  }
}
</style>
